import { ScheduledTaskDef } from "../../apis/mgmt/api";
import { DataFormWithButtonsLayout } from "../common/DataFormWithButtonsLayout";
import { EditableProps } from "../common/Editable";
import { ScheduledTaskDefForm } from "./ScheduledTaskDefForm";


export const ScheduledTaskDefEditable = function (
    props: EditableProps<ScheduledTaskDef>
) {
    return (
        <DataFormWithButtonsLayout editableProps={props}  saveAndStay={true}>
            <ScheduledTaskDefForm {...props} />
        </DataFormWithButtonsLayout>
    );

};
